// composables/useUserSession.js
export async function fetchChatData({ email, username, createUserToken, phone, setSession }) {
  const apiUrl = process.env.VUE_APP_API_URL

  try {
    const res = await fetch(`${apiUrl}/users/${email}`, {
      headers: { Authorization: `Bearer ${createUserToken}` }
    })

    if (!res.ok) {
      if (res.status === 400) {
        const createRes = await fetch(`${apiUrl}/users?verify_token=${createUserToken}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, email, phone })
        })

        if (createRes.status === 200) {
          const data = await createRes.json()
          return setSession({ valid: true, apiKey: data.newUser.apiKey, sessionId: data.newSession.id, messages: [] })
        }

        return setSession({
          valid: false,
          errorMsg: createRes.status === 403
            ? `Uy, parece que la clave para acceder a utilizar RichieAI no es válida 😕.\n\nSi eres parte del equipo de Briyam revisa que esta sea correcta.\n\nDe lo contrario puedes pedir ayuda al equipo de soporte.`
            : `Uy, parece que el serviciod de RichieAI esta teniendo inconvenientes 😕.\n\nSi se trata de una actualización estaremos muy pronto de vuelta contigo.\n\nSi el problema persiste, puedes pedir ayuda al equipo de soporte.`
        })
      }

      return setSession({
        valid: false,
        errorMsg: res.status === 402
          ? `Uy, parece falta configurar un correo para utilizar RichieAI 😕.\n\nRevisa que esta configuración esté presente o pide ayuda.`
          : `Uy, parece que el servicio de RichieAI está teniendo inconvenientes 😕.\n\nIntenta más tarde o consulta al equipo de soporte.`
      })
    }

    const data = await res.json()
    const messagesRes = await fetch(`${apiUrl}/chat-messages/${data.session.id}`, {
      headers: { 
        'Content-Type': 'application/json',
        'apiKey': data.user.apiKey
      },
    })
    if(messagesRes.status === 400){
      return setSession({
        valid: false,
        errorMsg: `Uy, parece falta configurar una session para utilizar RichieAI 😕.\n\nRevisa que esta configuración esté presente o pide ayuda.`
      })
    }
    const messages = await messagesRes.json()
    
    return setSession({ valid: true, apiKey: data.user.apiKey, sessionId: data.session.id, messages: messages })
  } catch (e) {
    return setSession({
      valid: false,
      errorMsg: `Uy, parece que el serviciod de RichieAI está teniendo inconvenientes 😕.\n\nIntenta más tarde o consulta al equipo de soporte.`
    })
  }
}
